module.exports = __webpack_public_path__ + "img/ape.f12cd8a8.png";